<app-menu></app-menu>

<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="book-status-page">
  <h1 class="success-title">Uhuu! O seu livro foi submetido com sucesso!</h1>
  <p class="subtitle">
    Seu livro foi enviado com sucesso e agora está em análise pelo <b>conselho editorial da feira do livro</b>,
    que revisará o conteúdo e o formato.<br>
    Você receberá um retorno por e-mail em <b>até 7 dias</b>.
  </p>
  <div class="status-progress-container">
    <b class="progress-title">Barra de progresso de revisão</b>
    <mat-progress-spinner *ngIf="isLoading" diameter="24" mode="indeterminate"></mat-progress-spinner>
    <div class="custom-progress-bar">
      <div class="progress-track">
        <div class="progress-fill" [ngStyle]="{'width': getProgressWidth()}"></div>
        <div class="progress-sep" style="left: 33%;"></div>
        <div class="progress-sep" style="left: 66%;"></div>
      </div>
      <div class="progress-labels">
        <span [class.active]="step >= 0">Submetido</span>
        <span [class.active]="step >= 1">Em revisão</span>
        <span [class.active]="step >= 2">Aguardando<br>sua aprovação</span>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>